




























import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import Context from "@/mixins/context";

// Enums
import { DataModules } from "@/store/modules/data";

// Types
import { IAffiliateTier } from "@/models/affiliate";
import { IBrand } from "@/models/brands";
import _ from "@/boot/lodash";

@Component({
  computed: {
    ...mapState({
      affiliateTiers(state, getters) {
        return _.orderBy(
          getters[`data/listArray`]({
            storeModule: DataModules.AFFILIATES_TIERS,
            scope: this.listScope
          }),
          ["name"],
          ["asc"]
        );
      }
    })
  }
})
export default class AffiliateTierSelect extends Mixins(
  RequestPromises,
  Context
) {
  // Props

  @Prop({ required: true })
  public value;

  @Prop({ required: true })
  public brandId!: IBrand["id"];

  @Prop({ default: true })
  public isRequired!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public affiliateTiers!: IAffiliateTier[];
  public listScope = "$all_affiliate_tiers";
  public isLoading = true;

  // Computed

  public get selected() {
    if (this.isLoading) return null;
    return this.value;
  }

  public set selected(value) {
    this.$emit("input", value);
  }

  // Life-cycle methods

  public async created() {
    try {
      await this.getAffiliateTiers();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isLoading = false;
    }
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.AFFILIATES_TIERS,
      scope: this.listScope,
      vm: this
    });
  }

  // Methods

  public getAffiliateTiers() {
    return this.$store.dispatch(`data/${DataModules.AFFILIATES_TIERS}/list`, {
      params: {
        limit: 0,
        brand_id: this.brandId
      },
      scope: this.listScope,
      vm: this
    });
  }
}
